import axios from 'axios';
import { API_URL } from '../config';

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo'));
  } catch {
    return null;
  }
};

// Attach the JWT only to requests going to our own API (never to third parties)
axios.interceptors.request.use((config) => {
  const token = getStoredUser()?.token;
  const isOwnApi = (config.url || '').startsWith(API_URL);
  if (token && isOwnApi && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Expired / invalid session -> back to login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isOwnApi = (error.config?.url || '').startsWith(API_URL);
    if (error.response?.status === 401 && isOwnApi && getStoredUser()) {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('selectedChat');
      localStorage.removeItem('chato_user');
      window.location.replace('/');
    }
    // the server says a temporary password is still in use (for example it was reset while the person was signed in)
    if (error.response?.status === 403 && error.response?.data?.code === 'PASSWORD_CHANGE_REQUIRED' && isOwnApi) {
      const u = getStoredUser();
      if (u && !u.mustChangePassword) { localStorage.setItem('userInfo', JSON.stringify({ ...u, mustChangePassword: true })); window.location.replace('/'); }
    }
    return Promise.reject(error);
  }
);
